<template>
  <div class="course-detail-box show-flex-box-c" v-if="courseDetailInfo">
    <div class="header-download-btn-bar">
      <header-download-button :appParams="routePath" />
    </div>
    <div class="course-detail-container show-flex-box-c">
      <dl class="show-flex-box-c">
        <dt class="show-flex-box-c">
          <div class="course-pic-bar show-flex-box-r">
            <div class="course-pic-content" v-if="showCourseCoverPic">
              <img :src="courseDetailInfo.cover.cover" >
            </div>
          </div>
          <div class="course-label" style="" v-if="!isFree">
            <span><img src="../../assets/user.png">{{courseDetailInfo.study_user_count}}次学习</span>
            <span class="course-price"><span>{{courseDetailInfo.price}}</span>/医学金</span>
          </div>
          <div class="course-label" style="" v-else>
            <span><img src="../../assets/user.png">{{courseDetailInfo.study_num}}次学习</span>
            <span class="course-price"> <span>限时免费</span></span>
            <span class="course-price2">医学金{{courseDetailInfo.price}}</span>
          </div>
          <div class="course-name">{{courseDetailInfo.title}}</div>
          <div class="course-author">
            <img :src="courseDetailInfo.author.avatar">
            <div>
              <div>{{courseDetailInfo.author.real_name}}</div>
              <div class="author-des">{{courseDetailInfo.author.title}} {{courseDetailInfo.author.hospital}}</div>
            </div>
          </div>
          <div class="course-name">课程详情</div>
          <div class="course-detail" v-html="courseDetailInfo.description" />
        </dt>
      </dl>
    </div>
    <!-- <div class="footer-download-btn-bar">
      <footer-download-button :appParams="routePath" />
    </div> -->
  </div>
</template>

<script>
  import headerDownloadButton from "@/components/basic/header_download_button";
  import footerDownloadButton from "@/components/basic/footer_download_button";
  import audioVideoPlayer from '@/components/video_player/audio_video_player';
  import filterTagBarComp from '@/components/course/filter_tag_bar_comp';
  import doctorInfoComp from '@/components/course/doctor_info_comp';
  import htmlText from "@/components/basic/html_text_comp";
  import sectionCourseComp from '@/components/course/new_section_course_comp';
  import courseInfo from '@/components/course/new_course_info_comp';
  import commentComp from '@/components/course/comment_comp';

  import $ from 'jquery';
  import Swiper from "swiper";
  import {shareWx} from '@/utils/share';
  import { dealShowTotaltime } from '@/utils/utils';
  import getIndexFunc from '@/tool/getIndexFunc';

  export default {
    components: {
      headerDownloadButton,
      footerDownloadButton,
      audioVideoPlayer,
      filterTagBarComp,
      doctorInfoComp,
      htmlText,
      sectionCourseComp,
      courseInfo,
      commentComp,

    },
    data(){
      return {
        courseId: '', // 课程ID

        courseDetailInfo: null,
        speakerInfo: null,

        showCourseCoverPic: true, // 是否显示课程的封面图 播放视频 就不显示图片了..
        playPauseStatus: true, // 视频是否暂停
        fullScreenStatus: false,
        isPlayingVideoCoverUrl: '',
        isPlayingVideoMediaUrl: '',
        auditionTime: 0,
        recordCount: 30,


        filterTagList: [
          {
            title: '课程介绍',
            type: 'courseIntroduce'
          },
          {
            title: '课程目录',
            type: 'courseCatalogue'
          },
          {
            title: '相关课程',
            type: 'relatedRecommend'
          },
          {
            title: '互动',
            type: 'interaction',
            summary: "",
          },
        ],
        selectedFilterType: '',
        chooseFilterType: 'courseIntroduce', // 课程介绍 课程目录 相关推荐 互动
        
        showOpenReplyComment: false, // 查看回复评论

        courseDetailSwiperModel: null,
        totalDuration: '', // 课程小节的总时长
        courseSectionList: [], // 课程小节
        lastViewSectionId: 0, // 上次看到的课程小节的id
        isPlayingSectionId: 0, // 正在播放的课程小节id

        relatedCommendedCourseList: [], // 推荐课程的列表

        courseCommentList: [], // 课程的评论列表
        courseCommentTotal: 0, // 课程的评论列表 总数
        commentObj: {
          type: 'courseSection',
          id: ''
        },
        listNoMore: false, // 课程评论 是否加载完
        subCommentNoMore: false, // 子评论 是否加载完
        publishCommentUserInfo: null, // 楼主的个人信息
        commentId: '', // 楼主的评论id
        subCommentParams: {},
        subCommentsList: [], // 子评论的列表信息
        subCommentsListLen: 0, // // 子评论的total




        wxDataInfo:{
          name:'',
          summary:'',
        },

      }
    },
    created() {
      this.courseId = this.$route.query.id;
      if (this.courseId) {
        this.configData();
      }
    },
    mounted(){
      this.clearAlertTitle();
    },
    computed: {
      routePath() { // 分享的链接
        if (this.courseId) {
          let path = `yspjsyl://course?id=${this.$route.query.id}`;
          return path;
        }

        return '';
      },
      isFree() {
        return this.courseDetailInfo.fee_type === 'free'
      },
    },
    methods: {
      configData(){
        this.reqCourseDetailInfo();
        // this.reqCourseSectionList();
        // this.reqRelRecommendCourseList();
        // this.reqCourseCommentList();
      },
      clearAlertTitle(){
        window.alert = function (name) {
          var iframe = document.createElement("IFRAME");
          iframe.style.display = "none";
          iframe.setAttribute("src", 'data:text/plain');
          document.documentElement.appendChild(iframe);
          window.frames[0].window.alert(name);
          iframe.parentNode.removeChild(iframe);
        }
      },
      // 获取详情
      reqCourseDetailInfo(){
        let params = { id: this.courseId };

        this.$zqclient.getCourse(params)
          .then(res => {
            if (res.data) {
              this.courseDetailInfo = res.data;
              // console.log(JSON.stringify(this.courseDetailInfo));
              this.wxDataInfo.name = this.courseDetailInfo.title;
              this.wxDataInfo.summary = this.courseDetailInfo.summary;

              this.speakerInfo = this.dealShowKeynoteSpeakerInfo(this.courseDetailInfo.lecturer_source_id, this.courseDetailInfo.lecturer_source_type, this.courseDetailInfo.lecturer_source);
              
              this.configSwiper();
              
              setTimeout(()=>{
                shareWx(this.wxDataInfo);
              },500);
            }
          })
          .catch(err=>{});
      },
      // 处理显示主讲人信息
      dealShowKeynoteSpeakerInfo(speakerId, speakerType, INFO){
        if (!speakerId || !INFO) {
          return null;
        }

        let speakerInfo = {};
        
        if (speakerType == 'doctor') {
          speakerInfo = {
            type: speakerType,
            id: INFO.id,
            avatarUrl: INFO.avatar_url ? INFO.avatar_url.o : '',
            name: INFO.name,
            field: INFO.position,
            hospital: INFO.hospital,
            isSub: INFO.is_sub
          };
        } else{
          speakerInfo = {
            type: speakerType,
            id: INFO.id,
            avatarUrl: INFO.avatar_url ? INFO.avatar_url.o : '',
            name: INFO.name,
            field: INFO.field,
            hospital: '',
            isSub: INFO.is_sub
          };
        }

        return speakerInfo;
      },
      configSwiper() {
        let courseInfoDom = $('.course-detail-swiper-box');
        if (courseInfoDom.length <= 0) {
          setTimeout(() => {
            this.configSwiper();
          }, 300);
          return ;
        }

        let _this = this;
        this.courseDetailSwiperModel = new Swiper('.course-detail-swiper-box', {
          on:{
            slideChange: function(){
              const type = _this.filterTagList[this.activeIndex].type;
              _this.chooseFilterType = type;
              _this.selectedFilterType = type;
              _this.showOpenReplyComment = false;
            },
          },
        });
      },
      // 获取课程小节
      reqCourseSectionList(){
        let params = { course_id: this.courseId };

        this.$client.getCourseSectionList(params)
          .then(res => {
            if (res.code == 200) {
              let returnInfo = res.data;
              // console.log(JSON.stringify(returnInfo));
              this.totalDuration = dealShowTotaltime(returnInfo.total_duration || 0, '0秒');
              this.courseSectionList = returnInfo.list;
            }
          })
          .catch(err=>{});
      },
      // 获取推荐课程的列表
      reqRelRecommendCourseList(){
        let params = { id: this.courseId };

        this.$client.getRelatedCommendCourseList(params)
          .then(res => {
            if (res.code == 200) {
              let returnInfo = res.data;
              // console.log(JSON.stringify(returnInfo));
              this.dealCourseList(returnInfo.list);
            }
          })
          .catch(err=>{});
      },
      // 处理推荐课程列表信息
      dealCourseList(list){
        let courseList = list;
        for (let i = 0; i < courseList.length; i++) {
          courseList[i].speakerInfo = this.dealShowKeynoteSpeakerInfo(courseList[i].lecturer_source_id, courseList[i].lecturer_source_type, courseList[i].lecturer_source);
        }

        this.relatedCommendedCourseList = courseList;
      },
      // 获取课程的评论列表数据
      reqCourseCommentList(){
        let params = {
          course_id: this.courseId,
          list_type: 'tree',
          page: 1,
          limit: 10,
        };

        this.$client.getCourseCommentList(params)
          .then(res => {
            if (res.code == 200) {
              let returnInfo = res.data;
              // console.log(JSON.stringify(returnInfo));
              this.courseCommentTotal = returnInfo.comment_total;
              this.courseCommentList = returnInfo.list;
              this.filterTagList[3].summary = this.courseCommentTotal;

              this.listNoMore = this.courseCommentTotal <= 10;
            }
          })
          .catch(err=>{});
      },
      // 打开回复的评论列表
      openReplyComment(clickInfo){
        this.publishCommentUserInfo = clickInfo.userInfo;
        this.commentId = clickInfo.commentId;

        this.subCommentParams = {
          pid: clickInfo.commentId,
          list_type: 'list',
          ppage: 1,
          limit: 10,
        };

        this.reqSubCommentList();
      },
      // 获取子评论列表
      reqSubCommentList(){
        this.$client.getSubCommentList(this.subCommentParams)
          .then(res => {
            if (res.code == 200) {
              this.showOpenReplyComment = true;

              let returnInfo = res.data;
              // console.log(JSON.stringify(returnInfo));
              this.subCommentsListLen = returnInfo.total;
              this.subCommentsList = returnInfo.list;

              this.subCommentNoMore = this.subCommentsListLen <= 10;
            }
          })
          .catch(err=>{});
      },
      // 查看更多 评论
      loadMoreCourseComment(){
        this.openAPP();
      },
      // 查看更多 子评论
      loadMoreSubComment(){
        this.openAPP();
      },
      openAPP(){
        alert('打开APP 查看更多信息');
      },
      // 课程介绍 课程目录 相关推荐 互动
      choosedThisFilterTagInfo(clickInfo){
        let choosedType = clickInfo.choosedType
        this.chooseFilterType = choosedType;
        this.selectedFilterType = choosedType;

        this.courseDetailSwiperModel.slideTo(clickInfo.index || 0, 500, false);
      },
      // 显示 价格/免费/进入学习
      dealShowCoursePrice(isFree, price){
        if (isFree) {
          return '免费';
        } else {
          return `¥${price}`;
        }
      },
      // 显示 vip价格
      dealShowVipCoursePrice(vipPrice){
        let showMsg = 'VIP ';
        if(vipPrice > 0){
          showMsg = showMsg + '¥' + vipPrice;
        } else {
          showMsg = showMsg + '免费';
        }

        return showMsg;
      },
      // 收藏 / 分享
      collectOrShareCourse(type, isStore){
        // console.log('type = ' + type);
        return ;
        CallRemoteFunction('loginToContinue').then(() => {
          switch (type) {
            case 'collect':
              ApiMessagePop.openLoading();

              let params = {
                id: this.courseId
              };
              
              if (isStore) {
                actions.cancelStoreCourseInfo(params);
              } else {
                actions.storeCourseInfo(params);
              }
              break;
            case 'share':
              Permission.checkAndGetPermissions({
                'photos': '相册',
                'storage': api.systemType != 'ios' ? '存储' : '',
              }).then((ret) => {
                if (ret.status) {
                  this.openSharePop();
                }
              })
              break;
          }
        });
      },
      // 关注该医生
      clickSubBtn(clickInfo){
        // console.log(JSON.stringify(clickInfo));
        return ;
        CallRemoteFunction('loginToContinue').then(() => {
          // lecturer
          if (clickInfo.type == 'doctor') {
            let params = {
              doctor_id: clickInfo.id
            };
            if (clickInfo.status == 1) {
              actions.cancelAttentionDoctor(params);
            } else {
              actions.attentionDoctor(params);
            }
          } else {
            let params = {
              lecturer_id: clickInfo.id
            };
            if (clickInfo.status == 1) {
              actions.cancelAttentionLecturer(params);
            } else {
              actions.attentionLecturer(params);
            }
          }
        });
      },
      // 显示 课程小节数量和总时长
      dealShowCourseTotalTime(){
        return `共${this.courseDetailInfo.course_section_num}节课，总时长${this.totalDuration}`;
      },
      // 点击这个小节课 开始看视频
      clickThisCourseSection(recieveInfo){
        // console.log(' --- 课程小节信息 --- ' + JSON.stringify(recieveInfo));
        // return ;
        this.playPauseStatus = true;

        this.showCourseCoverPic = false;

        this.isPlayingVideoCoverUrl = recieveInfo.logoUrl;
        this.isPlayingVideoMediaUrl = recieveInfo.mediaUrl;

        let isAudition = recieveInfo.isAudition;
        let auditionTime = recieveInfo.auditionTime;
        let canView = recieveInfo.canView;

        if (!canView && !recieveInfo.isFree && isAudition && auditionTime > 0) {
          this.auditionTime = auditionTime;
        } else {
          this.auditionTime = 0;
        }

        // let courseId = this.courseId + '';
        // CurrentPlayingCourseSectionId.val(courseId, courseSectionId); // 存储到 globalData 中

        let courseSectionId = recieveInfo.courseSectionId;
        setTimeout(() => {
          // this.lastViewSectionId = courseSectionId;
          this.isPlayingSectionId = courseSectionId;
        }, 10);

        // 播放该课程小节视频
        setTimeout(() => {
          this.playPauseStatus = false;
        }, 100);

        // setTimeout(()=>{
        //   if (recieveInfo.isFree && !canView) { // 是免费课且canView为0 就订阅它
        //     this.confirmBuyThisFreeHealthyCourse(false);
        //   }
        // },500);
      },
      // 付费课程的 走购买流程
      getClickSectionInfo: function(recieveInfo) {
        // alert('打开APP去购买该课程哦~');
        this.openAPP();
        // console.log(JSON.stringify(recieveInfo));
        return ;
        const type = recieveInfo.type || 'buy';
        // const showMsg = type == 'buy' ? '购买该课程，观看完整版内容' : '试看结束，购买该课程，观看完整版内容';
        const showMsg = '购买该课程，观看完整版内容';
        const popType = type == 'buy' ? 'one' : 'two';

        route('/phone_relation_pop', {
          callback: defineCallback(this.confirmToOpenPayPop),
          type: popType,
          remindMsg: showMsg,
          remindTitle: '试看结束',
          tellphone: showMsg
        });
      },
      getAudioVideoClickInfo: function(audioVideoClickData) {
        const playId = audioVideoClickData.id;
        const playData = audioVideoClickData.data;
        const buttonType = playData.buttonType;
        
        switch (buttonType) {
          case 'playPause':

          break;
          case 'fullScreen':
          case 'goBack':
            this.setScreenShowStatusWithFullChange();
          break;
          case 'progressBar':

          break;
          case 'tryWatchPayment': // 试听
            this.exitFullScreen();
            setTimeout(() => {
              this.getClickSectionInfo({type: 'tryWatchPayment'});
            }, 800);
            break;
        }
      },
      setScreenShowStatusWithFullChange: function() {
        this.setFullScreenStatus();
        // this.setScreenOrientationByFullStatus();
        // this.setKeybackStatusGlobalData(!this.fullScreenStatus);
      },

      // 播放控制 start
      getAudioVideoPlayInfo: function(videoData) {
        // console.log(' ---------------- ' + JSON.stringify(videoData));
        this.recordFootprintByVideoPlayInfo(videoData);
      },
      // 记录播放的进度
      recordFootprintByVideoPlayInfo(videoData){
        let videoInfo = videoData.data;
        let stateType = videoInfo.statusType;
        let curTime = videoInfo.currentTime || 0;
        let duration = videoInfo.duration || 1;
        let progressPercent = parseInt(curTime / duration * 100) / 100;

        switch (stateType) {
          case 'play':
            this.recordWatchProgress(progressPercent);
          break;
          case 'timeupdate':
            if (this.recordCount <= 0) {
              this.recordCount = 30;
              this.recordWatchProgress(progressPercent);
            }

            this.recordCount = this.recordCount - 1;
          break;
          case 'pause':
            this.recordWatchProgress(progressPercent);
          break;
          case 'ended':
            this.recordWatchProgress(1);
            this.checkIsCanPlayNextCourseSection();
          break;
          case 'tryWatchOver':
            this.exitFullScreen();
            setTimeout(() => {
              this.getClickSectionInfo({type: 'tryWatchPayment'});
            }, 800);
          break;
        }
      },
      // 调接口
      recordWatchProgress(progress) {
        console.log('progress = ' + progress);
        return ;
        let params = {
          type: 'section',
          // course_section_id: this.lastViewSectionId,
          course_section_id: this.isPlayingSectionId,
          progress: progress
        };

        actions.changePlayProgress(params);
      },
      // 是否能播放下一个课程小节视频
      checkIsCanPlayNextCourseSection(){
        const isPlayingId = this.isPlayingSectionId;
        const list = this.courseSectionList;
        let isPlayingIndex = getIndexFunc.getIndexById(isPlayingId, list);
        if (isPlayingIndex < list.length - 1) {
          const nextSectionInfo = list[isPlayingIndex+1];
          const canView = this.courseDetailInfo.can_view;
          const isAudition = nextSectionInfo.is_audition;

          const sendInfo = {
            canView: canView,
            isFree: this.courseDetailInfo.is_free,
            isAudition: isAudition,
            auditionTime: nextSectionInfo.audition_time,
            courseSectionId: nextSectionInfo.id,
            videoType: nextSectionInfo.type,
            logoUrl: nextSectionInfo.logo_url && nextSectionInfo.logo_url.o || '',
            mediaUrl: nextSectionInfo.media_url,
          };

          if (canView || isAudition) { // 可以看 / 可以试看
            this.clickThisCourseSection(sendInfo);
          } else {
            if (this.courseDetailInfo.isFree) {
              this.clickThisCourseSection(sendInfo);
            } else {
              this.getClickSectionInfo({type: 'buy'});
            }
          }
        }
      },
      // 退出全屏
      exitFullScreen(){
        this.setFullScreenStatus(false);
        this.playPauseStatus = true;

        // this.setScreenOrientationByFullStatus();
        // this.setKeybackStatusGlobalData(!this.fullScreenStatus);
      },
      setFullScreenStatus: function(isFull) {
        this.fullScreenStatus = typeof(isFull) != 'undefined' ? isFull : !this.fullScreenStatus;
        console.log('this.fullScreenStatus = ' + this.fullScreenStatus);
      },
      setScreenOrientationByFullStatus: function() {
        return ;
        let orientationType = this.fullScreenStatus ? 'auto_landscape' : 'portrait_up';

        api.setScreenOrientation({
          orientation: orientationType
        });
      },





      // 关闭 回复 '弹窗'
      closeReplyComment(){
        setTimeout(() => {
          this.showOpenReplyComment = false;
        }, 100);
      },


    },
  }
</script>
<style>
.course-detail{
  font-size: 0.13rem;
  padding: 0rem 0.1rem;
 }
.course-detail img{
    width: 100%;
  }
</style>
<style lang="less" scoped>
  html,
  body {
    width: 100%;
    height: 100%;
    background: #FFF;
  }
  .course-author {
    font-size: 0.2rem;
    margin: 0rem 0.2rem;
    background: #F6F6F6;
    padding: 0.05rem 0.2rem;
    border-radius: 0.1rem;
    >img {
      width: 0.4rem;
      height:0.4rem;
      border-radius: 0.2rem;
      background: lightgray;
    }
    display: flex;
    align-items: center;
    div {
      display: inline-flex;
      flex-direction: column;
      font-size: 0.13rem;
      padding: 0.05rem 0.05rem;
    }
    .author-des {
      color: #666666;
    }
  }
  .course-name {
    font-size: 0.2rem;
    padding: 0.2rem;
  }
  
  .course-label {
        width:100%;height:0.5rem;background:yellow;background: linear-gradient(90deg, #FCE2A5 0%, #FFB665 100%);
        font-size: 0.12rem;
        display: flex;
        // justify-content: center;
        align-items: center;
        justify-content: space-between;
        > span {
         img {
          width: 0.11rem;
          margin-right: 0.02rem;
          }
          color: rgba(153, 153, 153, 1);
          font-weight: 500;
          font-size: 0.12rem;
          font-family: PingFangSC-Medium, PingFang SC;
          padding: 0.12rem;
          
        }
         .course-price {
            color: #191919;
            margin-left: 0.55rem;
            span {
              font-size: 0.2rem;
            }
            
          }
          .course-price2 {
            color: #191919;
            text-decoration: line-through;
          }
        .course-vip {
          background: red;
          padding: 0.1rem 0.15rem;
          margin-right: 0.12rem;
          border-radius: 0.05rem;
          color: white;
          font-size: 0.13rem;

        }
      }
  .course-detail-box{
    width: 100%;
    height: 100%;
    > .header-download-btn-bar{
      width: 100%;
      flex-shrink: 0;
    }
    > .course-detail-container{
      width: 100%;
      flex-grow: 1;
      > dl{
        width: 100%;
        height: 100%;
        > dt {
          width: 100%;
          flex-shrink: 0;
          > .course-pic-bar {
            width: 100%;
            height: 2.11rem;
            flex-shrink: 0;
            > .course-pic-content {
              position: relative;
              width: 100%;
              height: 100%;
              > img {
                display: block;
                width: 100%;
                height: 100%;
                object-fit: cover;
              }
              > div{
                position: absolute;
                left: 0.16rem;
                bottom: 0.12rem;
                z-index: 5;
                > h3{
                  width: 0.58rem;
                  height: 0.24rem;
                  background: rgba(0, 0, 0, 0.5);
                  border-radius: 0.04rem;
                  > span{
                    font-size: 0.12rem;
                    font-family: PingFangSC-Regular, PingFang SC;
                    font-weight: 400;
                    color: #FFFFFF;
                    line-height: 0.16rem;
                  }
                }
                > .is-vip-course{
                  margin-right: 0.06rem;
                }
              }
            }
            > .course-section-video-bar{
              width: 100%;
              height: 100%;
              flex-shrink: 0;
            }
          }
          > .filter-bar{
            width: 100%;
            flex-shrink: 0;
            background: #FFFFFF;
            > div{
              width: 100%;
            }
            > .reply-comment-bar{
              height: 0.4rem;
              align-items: center;
              justify-content: space-between;
              > h3{
                flex-shrink: 0;
                align-items: center;
                > strong{
                  margin-right: 0.03rem;
                  margin-left: 0.16rem;
                  font-size: 0.15rem;
                  font-family: PingFangSC-Medium, PingFang SC;
                  font-weight: 500;
                  color: #333333;
                  line-height: 0.22rem;
                }
                > span{
                  padding-top: 2px;
                  font-size: 0.12rem;
                  font-family: PingFangSC-Regular, PingFang SC;
                  font-weight: 400;
                  color: #999999;
                  line-height: 0.17rem;
                }
              }
              > em{
                width: 0.2rem;
                height: 0.2rem;
                flex-shrink: 0;
                margin-right: 0.16rem;
                background: url('../../assets/course/exit_icon.png') center center no-repeat;
                background-size: 100% 100%;
              }
            }
          }
        }
        > dd{
          width: 100%;
          height: 0;
          flex-grow: 1;
          > div{
            width: 100%;
            height: 100%;
            > .course-introduce-bar{
              width: 100%;
              height: 100%;
              overflow-y: scroll;
              background: #FFFFFF;
              > .course-detail-info-bar{
                box-sizing: border-box;
                width: 100%;
                padding: 0.16rem;
                border-bottom: 0.08rem solid #F8F8F8;
                flex-shrink: 0;
                > h3{
                  width: 100%;
                  margin-bottom: 0.12rem;
                  flex-shrink: 0;
                  > strong{ 
                    font-size: 0.18rem;
                    font-family: PingFangSC-Medium, PingFang SC;
                    font-weight: 500;
                    color: #333333;
                    line-height: 0.25rem;
                  }
                }
                > .course-price-bar{
                  width: 100%;
                  margin-bottom: 0.1rem;
                  align-items: center;
                  flex-shrink: 0;
                  > span{
                    font-size: 0.2rem;
                    font-family: PingFangSC-Medium, PingFang SC;
                    font-weight: 500;
                    color: #F44900;
                    line-height: 0.28rem;
                  }
                  > h3{
                    min-width: 0.48rem;
                    height: 0.16rem;
                    margin-left: 0.06rem;
                    flex-shrink: 0;
                    background: #FFEECC;
                    border-radius: 0.04rem;
                    > span{
                      font-size: 0.1rem;
                      font-family: PingFangSC-Regular, PingFang SC;
                      font-weight: 400;
                      color: #97762A;
                      line-height: 0.14rem;
                    }
                  }
                }
                > .collect-forward-btn-bar{
                  width: 100%;
                  flex-shrink: 0;
                  justify-content: space-between;
                  align-items: flex-end;
                  > span{
                    font-size: 0.12rem;
                    font-family: PingFangSC-Regular, PingFang SC;
                    font-weight: 400;
                    color: #999999;
                    line-height: 0.16rem;
                  }
                  > div{
                    > h3{
                      flex-shrink: 0;
                      align-items: flex-end;
                      > em{
                        transition: all 0.5s;
                        width: 0.2rem;
                        height: 0.2rem;
                        flex-shrink: 0;
                        margin-right: 0.04rem;
                        background: url('../../assets/course/not_collect_icon.png') center center no-repeat;
                        background-size: 100% 100%;
                        &:active{
                          transform: scale(1.2); 
                        }
                      }
                      > span{
                        font-size: 0.12rem;
                        font-family: PingFangSC-Regular, PingFang SC;
                        font-weight: 400;
                        color: #999999;
                        line-height: 0.16rem;
                      }
                    }
                    > .forword-icon{
                      margin-left: 0.22rem;
                      > em{
                        background: url('../../assets/course/forward_icon.png') center center no-repeat;
                        background-size: 100% 100%;
                      }
                    }
                    > .is-collect{
                      > em{
                        background: url('../../assets/course/is_collect_icon.png') center center no-repeat;
                        background-size: 100% 100%;
                      }
                    }
                  }
                }
              }
              > .course-doctor-and-detail-bar{
                padding-left: 0.16rem;
                padding-right: 0.16rem;
                > div{
                  width: 100%;
                  margin-top: 0.2rem;
                  flex-shrink: 0;
                  > .doctor-list-info-bar{
                    width: 100%;
                    > li{
                      width: 100%;
                      height: 0.54rem;
                      margin-bottom: 0.16rem;
                      flex-shrink: 0;
                      > div{
                        width: 100%;
                        height: 100%;
                      }
                    }
                    >li:last-child{
                      margin-bottom: 0;
                    }
                  }
                  > .course-detail-info{
                    box-sizing: border-box;
                    width: 100%;
                    margin-bottom: 0.16rem;
                    flex-shrink: 0;
                  }
                }
              }
              .title-bar{
                width: 100%;
                margin-bottom: 0.1rem;
                flex-shrink: 0;
                > span{
                  font-size: 0.15rem;
                  font-family: PingFangSC-Medium, PingFang SC;
                  font-weight: 500;
                  color: #333333;
                  line-height: 0.21rem;
                }
              }
            }
            > .course-catalogue-bar{
              box-sizing: border-box;
              padding: 0.16rem 0.16rem 0;
              width: 100%;
              height: 100%;
              background: #F8F8F8;
              overflow-y: scroll;
              > strong{
                flex-shrink: 0;
                font-size: 0.13rem;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: #666666;
                line-height: 0.18rem;
              }
              > ul{
                width: 100%;
                padding-top: 0.08rem;
                flex-shrink: 0;
                > li {
                  width: 100%;
                  margin-bottom: 0.08rem;
                  flex-shrink: 0;
                }
              }
            }
            > .related-recommend-course-bar{
              width: 100%;
              height: 100%;
              overflow-y: scroll;
              background: #FFFFFF;
              > ul{
                padding: 0.16rem 0.16rem 0;
                > li{
                  width: 100%;
                  margin-bottom: 0.08rem;
                  flex-shrink: 0;
                }
              }
              > h3{
                width: 100%;
                padding-top: 0.16rem;
                padding-bottom: 0.24rem;
                > span{
                  font-size: 0.12rem;
                  font-family: PingFangSC-Regular, PingFang SC;
                  font-weight: 400;
                  color: #999999;
                  line-height: 0.17rem;
                }
              }
            }
            > .course-interaction-bar{
              box-sizing: border-box;
              padding: 0.16rem 0.16rem 0;
              width: 100%;
              height: 100%;
              overflow-y: scroll;
              background: #FFFFFF;
              > .course-interaction-content{
                width: 100%;
                > h3{
                  width: 100%;
                  align-items: center;
                  flex-shrink: 0;
                  > span{
                    margin-right: 0.04rem;
                    font-size: 0.15rem;
                    font-family: PingFangSC-Medium, PingFang SC;
                    font-weight: 500;
                    color: #333333;
                    line-height: 0.22rem;
                  }
                  > strong{
                    padding-top: 2px;
                    font-size: 0.12rem;
                    font-family: PingFangSC-Regular, PingFang SC;
                    font-weight: 400;
                    color: #999999;
                    line-height: 0.17rem;
                  }
                }
                > ul{
                  padding-top: 0.16rem;
                  width: 100%;
                  > li{
                    width: 100%;
                    margin-bottom: 0.16rem;
                    flex-shrink: 0;
                    > div{
                      width: 100%;
                    }
                  }
                }
                > div{
                  flex-shrink: 0;
                  width: 100%;
                  height: 0.52rem;
                  > span {
                    font-size: 0.12rem;
                    font-family: PingFangSC-Regular, PingFang SC;
                    font-weight: 400;
                    color: #999999;
                    line-height: 0.17rem;
                    margin-right: 0.04rem;
                  }
                  > em {
                    width: 0.14rem;
                    height: 0.14rem;
                    flex-shrink: 0;
                    background: url('../../assets/course/down_arrow_icon.png')
                      center center no-repeat;
                    background-size: 100% 100%;
                  }
                }
              }
              > .sub-comment-list-bar{
                > ul{
                width: 100%;
                  > li{
                    width: 100%;
                    flex-shrink: 0;
                    margin-bottom: 0.16rem;
                    > div{
                      width: 100%;
                    }
                  }
                }
                > div{
                  flex-shrink: 0;
                  width: 100%;
                  height: 0.52rem;
                  > span {
                    font-size: 0.12rem;
                    font-family: PingFangSC-Regular, PingFang SC;
                    font-weight: 400;
                    color: #999999;
                    line-height: 0.17rem;
                    margin-right: 0.04rem;
                  }
                  > em {
                    width: 0.14rem;
                    height: 0.14rem;
                    flex-shrink: 0;
                    background: url('../../assets/course/down_arrow_icon.png')
                      center center no-repeat;
                    background-size: 100% 100%;
                  }
                }
              }
            }
          }
        }
      }
    }
    > .footer-download-btn-bar{
      width: 100%;
      flex-shrink: 0;
    }
  }
</style>


// WEBPACK FOOTER //
// src/views/Course/index.vue